let interfaceDate = [
  {
    //获取用户菜单
    interfaceName: "getUserIdMenuAPP",
    params: {},
    flag: false
  },
  {
    //获取全部菜单
    interfaceName: "getAllMenuAPP",
    params: {},
    flag: false
  },
];
export default interfaceDate;
